import React from 'react';
import { graphql } from 'gatsby';
import SiteLayout from '../components/SiteLayout';
import SEO from '../components/SEO';
import ContentBlocks from '../components/GlobalContentBlocks/ContentBlocks';

const index = ({
  location,
  data: {
    wpgraphql: { 
      pageBy: page
    },
  },
}) => (  
  <SiteLayout location={location} showHomeBanner={page.acfPageHome.showHomeBanner}>
    <SEO page={page} path={location.pathname} title='Email Delivery, API, Marketing Service' description="SendGrid delivers your transactional and marketing emails through the world's largest cloud-based email delivery platform. Send with confidence."/>    
    <ContentBlocks blocks={page.acfGlobalContentBlocks.contentBlocks} />
  </SiteLayout>
);

export default index;

export const query = graphql`
  query {
    wpgraphql {
      pageBy(pageId: 11813) {
        ...HomePageFragment
        ...SEOPageFragment
        ...HeroBlockFragment
        ...SuperBlockFragment
        ...ButtonBlockFragment
        ...ResourcesPreviewBlockFragment
        ...ApiIntegrationsBlockFragment
        ...DependableSendingBlockFragment
        ...SubHeroBannerBlockFragment
        ...ProductFeaturesBlockFragment
      }
    }
  }
`;